import {
  Header1,
  Instruction,
  InstructionWithImage, InstructionWithTextarea,
} from '../../BlockComponent'
import { LastCard } from "../common";

export const Content_2_3_A = [
  Instruction("typography_0"),
  InstructionWithTextarea("typography_0_1"),
  Instruction("typography_0_2"),
  Instruction("typography_0_3"),
  Instruction("typography_0_4"),
  Instruction("typography_0_5"),
  Instruction("typography_0_6"),
  Instruction("typography_0_7"),
  Instruction("typography_0_8"),
  Instruction("typography_0_9"),
  Instruction("typography_0_10"),

  Header1("typography_3"),
  Instruction("typography_4"),
  Instruction("typography_5"),
  Instruction("typography_6"),

  Instruction("typography_10"),
  Instruction("typography_11"),
  Instruction("typography_12"),
  Instruction("typography_13"),
  Instruction("typography_14"),

  Instruction("typography_15"),
  Instruction("typography_16"),
  Instruction("typography_17"),
  Instruction("typography_18"),

  Header1("typography_18_0_1"),
  Instruction("typography_18_0_2"),
  Instruction("typography_18_0_3"),
  Instruction("typography_18_0_4"),
  Instruction("typography_18_0_5"),

  Instruction("typography_20"),
  Instruction("typography_21"),
  Instruction("typography_22"),
  Instruction("typography_23"),
  Instruction("typography_24"),

  Header1("typography_24_0_1"),
  Instruction("typography_25"),

  Instruction("typography_26"),
  InstructionWithImage("typography_27", "1"),
  InstructionWithImage("typography_28", "2"),

  Instruction("typography_30_0_1"),
  Instruction("typography_30_0_2"),
  Instruction("typography_30_0_3"),
  Instruction("typography_30_0_4"),
  Instruction("typography_30_0_5"),
  Instruction("typography_30_0_6"),
  Instruction("typography_30_0_7"),

  Instruction("typography_31"),

  ...LastCard,
];